<script>
import StoreButton from '@maison/components/store/StoreButton.vue';
import StoreResultsInModal from '@maison/components/store/StoreResultsInModal';
import storeResultsInModal from '@phoenix/mixins/components/store/storeResultsInModal';

export default {
  components: { StoreResultsInModal, StoreButton },

  mixins: [storeResultsInModal],

  props: {
    reference: {
      type: String,
      default: '',
    },
    displayStock: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    inStock() {
      return this.storesByStock.true;
    },

    noStock() {
      return this.storesByStock.false;
    },

    showNoResult() {
      return this.displayNoResult && !this.inStock.length;
    },

    storesByStock() {
      return this.stores.reduce(
        (acc, store) => {
          acc[store.hasStock]?.push(store);
          return acc;
        },
        { true: [], false: [] },
      );
    },
  },

  methods: {
    boutiqueAppointmentLink(pageId) {
      return window.route('boutique_appointment_form', { page_id: pageId, reference: this.reference });
    },
  },
};
</script>

<template>
  <div>
    <div v-if="isLoading" class="flex flex-grid--center">
      <div class="loader loader--dark"><div class="loader__inner" /></div>
    </div>

    <template v-else>
      <ul
        v-if="inStock.length"
        class="store-finder-modal__menu menu menu--sm menu--border-full-width max-sm:menu--small"
      >
        <li
          v-for="store in inStock"
          :key="store.id"
          class="store-finder-modal__menu-item menu__item"
          data-cy="store-result-item-in-stock"
        >
          <a
            :href="storeLink(store.permalink)"
            class="store-finder-modal__menu-item-content menu__entry menu__entry--tight menu__link menu__toggle"
            v-on="followStoreLinkOnClick ? {} : { click: () => storeClick(store) }"
          >
            <address class="checkout__store-list-address">
              <strong>{{ store.name }}</strong>
              <span class="store-finder-modal__menu-item-address">
                {{ getFullAddress(store) }}
              </span>
            </address>

            <span v-if="displayStock" class="tag tag--paladium store-finder-modal__boutique-availability">
              {{ $t('Product.inStock') }}
            </span>
          </a>

          <div class="store-finder-modal__buttons">
            <store-button
              :to="storeLink(store.permalink)"
              :label="$t('ProductPage.CTA.boutiqueInformation.mobile')"
              mobile-only
              :follow-store-link-on-click="followStoreLinkOnClick"
              @click="storeClick(store)"
            />

            <store-button
              :to="boutiqueAppointmentLink(store.id)"
              :label="$t('ProductPage.CTA.contactYourBoutique.mobile')"
              mobile-only
            />

            <store-button
              :to="storeLink(store.permalink)"
              :label="$t('ProductPage.CTA.boutiqueInformation')"
              icon="pin-16"
              desktop-only
              :follow-store-link-on-click="followStoreLinkOnClick"
              @click="storeClick(store)"
            />

            <store-button
              :to="boutiqueAppointmentLink(store.id)"
              :label="$t('ProductPage.CTA.contactYourBoutique')"
              icon="calendar-outline-16"
              desktop-only
            />
          </div>
        </li>
      </ul>

      <store-results-in-modal
        v-if="noStock.length"
        :stores="noStock"
        :is-loading="isLoading"
        :display-no-result="displayNoResult"
        :no-result-title="noResultTitle"
        :no-result-text="noResultText"
        :no-result-c-t-a="noResultCTA"
        :follow-store-link-on-click="followStoreLinkOnClick"
        store-list-classes="store-finder-modal__retailers store-finder-modal__menu menu menu--sm menu--border-full-width max-sm:menu--small"
        store-list-link-classes="store-finder-modal__menu-item-content"
        @store-click="storeClick"
      >
        <template #before-store-list>
          <div class="rich-text store-finder-modal__retailers-availability">
            <span v-html="$t('ProductAvailability.store.cannotGuaranteed')" />
          </div>
        </template>
      </store-results-in-modal>

      <div v-else-if="showNoResult" class="text-center" data-cy="store-result-no-result">
        <h4 v-if="noResultTitle">{{ noResultTitle }}</h4>
        <p v-if="noResultText">{{ noResultText }}</p>
        <div v-if="noResultCTA" class="mt-base"><c-t-a v-bind="noResultCTA" /></div>
      </div>
    </template>
  </div>
</template>
